
export const FETCH_ORDER_HISTORY_IN_PROGRESS = "FETCH_ORDER_HISTORY_IN_PROGRESS"

export const FETCH_ORDER_HISTORY_COMPLETE = "FETCH_ORDER_HISTORY_COMPLETE"

export const FETCH_ORDER_HISTORY_FAILED = "FETCH_ORDER_HISTORY_FAILED"


